export const set_stock_adjust_items = (stock_adjust_items) => {
    return {
        type: 'SET_STOCK_ADJUST_ITEMS',
        stock_adjust_items
    };
}
